module.exports = __webpack_public_path__ + "static/media/solar-brown-circle.3c2d3763.svg";